// Phase 10 — Pk Effectiveness Engine v1 API client.
// Thin axios wrappers; same convention as ``api/optimisation.js``.
import { api as client } from "@/api/client";

const BASE = "/api/pk-campaigns";

export const pkCampaigns = {
    create: (body) => client.post(BASE, body).then((r) => r.data),
    list: (params = {}) => client.get(BASE, { params }).then((r) => r.data),
    get: (id) => client.get(`${BASE}/${id}`).then((r) => r.data),
    cancel: (id) =>
        client.post(`${BASE}/${id}/cancel`).then((r) => r.data),
    // Phase 14.8 W2 — atomic delete (Mongo doc + filesystem artefacts).
    // 204 on success, 409 on queued/running (must cancel first), 404 on
    // unknown id or cross-tenant access.
    remove: (id) => client.delete(`${BASE}/${id}`).then((r) => r.status),
    sampleTrajectory: (id, sampleIdx) =>
        client
            .get(`${BASE}/${id}/samples/${sampleIdx}/trajectory`)
            .then((r) => r.data),
    // Phase 14.10 hot-fix — auth-bearing PDF/DOCX download. Mirrors
    // `geometryCampaigns.downloadReport`. PM-reported bug: anchor-href
    // download dropped the Authorization header (axios interceptor at
    // api/client.js:21 only fires for axios fetches, not native
    // anchor navigation). Returning the blob lets the page wire
    // `URL.createObjectURL` + temp anchor click + revoke.
    downloadReport: (id, format = "pdf") =>
        client
            .get(`${BASE}/${id}/report`, {
                params: { format },
                responseType: "blob",
            })
            .then((r) => {
                const cd = r.headers?.["content-disposition"] || "";
                const match = cd.match(/filename="?([^"]+)"?/);
                return {
                    blob: r.data,
                    filename: match
                        ? match[1]
                        : `pk_report_${id}.${format}`,
                };
            }),
    reportUrl: (id, format = "pdf") =>
        `${BASE}/${id}/report?format=${encodeURIComponent(format)}`,
    // Phase 10.1 — perturbation registry (33 variables) optionally
    // resolved against a scenario's nominal field values.
    registry: (params = {}) =>
        client.get(`${BASE}/registry`, { params }).then((r) => r.data),
    // Phase 12 — server-rendered convergence chart for target_pk
    // campaigns. Returned as a blob so the bearer header travels with it.
    convergencePng: (id) =>
        client
            .get(`${BASE}/${id}/convergence.png`, { responseType: "blob" })
            .then((r) => r.data),
};

export default pkCampaigns;
